import { LIST_SIZE } from '@/blocks/constants'
import { Accordion, type AccordionProps } from '@/components/Accordion'
import {
  Container,
  type BackgroundColor,
  type ContainerProps,
  type Space,
} from '@/components/Container'
import { BodyM, HeadingL, HeadingS, type TypographyColorModifier } from '@/components/Typography'
import { clearBuilderProps } from '@/core/utils/dom/clearBuilderProps'
import type { TitleProps } from '@/models'

import { builderLightText } from '../utils'

export interface AccordionBlockProps extends AccordionProps {
  id?: string
  size: 'm' | 'l'
  title?: TitleProps
  subtitle?: TitleProps
  space: Space
  background: BackgroundColor
  backgroundColor?: string
  colorModifier?: TypographyColorModifier
}

const AccordionBlock = ({
  id,
  title,
  subtitle,
  size,
  space,
  background,
  backgroundColor,
  colorModifier,
  ...accordionProps
}: AccordionBlockProps) => {
  const TitleComponent = size === LIST_SIZE.lg ? HeadingL : HeadingS
  const lightText = builderLightText(colorModifier)

  clearBuilderProps(accordionProps)

  const containerProps: ContainerProps = {
    spaceOut: space,
    id: id,
    backgroundColor: background,
    backgroundColorHex: backgroundColor,
    className: 'eu-sp-m',
  }

  return (
    <Container {...containerProps}>
      {title && title.text && (
        <TitleComponent light={lightText} className="eu-sm-1" tag={title.tag || 'h3'}>
          {title.text}
        </TitleComponent>
      )}
      {subtitle && subtitle.text && (
        <BodyM light={lightText} className="eu-sm-2" tag={subtitle.tag || 'p'}>
          {subtitle.text}
        </BodyM>
      )}
      <Accordion
        {...accordionProps}
        background={background}
        className="content"
        lightText={lightText}
      />
    </Container>
  )
}

export default AccordionBlock
